var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1649819080259,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 31064,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M752 169.6a64 64 0 0 1 64 64v576a64 64 0 0 1-64 64h-480a64 64 0 0 1-64-64v-576a64 64 0 0 1 64-64h480z m0 56h-480a8 8 0 0 0-7.776 6.176L264 233.6v576a8 8 0 0 0 6.176 7.776l1.824 0.224h480a8 8 0 0 0 7.776-6.176l0.224-1.824v-576a8 8 0 0 0-6.176-7.776L752 225.6z m-92.544 394.4c3.392 0 6.144 2.752 6.144 6.144v21.856a28 28 0 0 1-28 28h-273.056a6.144 6.144 0 0 1-6.144-6.144v-21.856c0-15.456 12.544-28 28-28h273.056z m0-136c3.392 0 6.144 2.752 6.144 6.144V512a28 28 0 0 1-28 28h-273.056a6.144 6.144 0 0 1-6.144-6.144V512c0-15.456 12.544-28 28-28h273.056z m0-136c3.392 0 6.144 2.752 6.144 6.144v21.856a28 28 0 0 1-28 28h-273.056a6.144 6.144 0 0 1-6.144-6.144v-21.856c0-15.456 12.544-28 28-28h273.056z",
    "p-id": 31065,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.b1b25df0.svg";
export { ForwardRef as ReactComponent };